module.exports = __webpack_public_path__ + "static/media/noReportIcon.8d5c590f.svg";